import { useState, useEffect } from 'react';

function useWebSocket() {
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('connecting');
  const wsUrl = process.env.REACT_APP_WS_URL;

  useEffect(() => {
    let ws;
    let reconnectAttempts = 0;
    const maxReconnectAttempts = 5;
    const initialReconnectDelay = 1000;
    const maxReconnectDelay = 30000;

    function connectWebSocket() {
      ws = new WebSocket(wsUrl);

      ws.onopen = () => {
        console.log('WebSocket connection established');
        setStatus('connected');
        setError(null);
        reconnectAttempts = 0;
      };

      ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.type === 'onlineUsers') {
            setOnlineUsers(data.count);
          }
        } catch (err) {
          console.error('Error parsing WebSocket message:', err);
          setError('Failed to parse server message.');
        }
      };

      ws.onerror = (err) => {
        // Suppress errors during page refresh or abrupt disconnections
        if (ws.readyState === WebSocket.CLOSED || ws.readyState === WebSocket.CLOSING) {
          console.warn('WebSocket error during disconnection:', err);
        } else {
          console.error('WebSocket error:', err);
          setError('WebSocket encountered an error.');
        }
      };

      ws.onclose = () => {
        console.log('WebSocket connection closed');
        setStatus('disconnected');

        if (reconnectAttempts < maxReconnectAttempts) {
          const reconnectDelay = Math.min(
            initialReconnectDelay * Math.pow(2, reconnectAttempts),
            maxReconnectDelay
          );

          console.log(`Reconnecting in ${reconnectDelay / 1000} seconds...`);
          setError(`Connection lost. Reconnecting in ${reconnectDelay / 1000} seconds...`);
          setStatus('reconnecting');

          setTimeout(() => {
            reconnectAttempts++;
            connectWebSocket();
          }, reconnectDelay);
        } else {
          setError('Max reconnection attempts reached. Please refresh the page.');
          setStatus('failed');
        }
      };
    }

    connectWebSocket();

    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [wsUrl]);

  return { onlineUsers, error, status };
}

export default useWebSocket;